/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { Layout, SelectableItemContainer } from '../../components/selectableItem/selectableItemContainer'
import { ISelectableItem } from '../../components/selectableItem/selectableItemConverters'
import { SkodaPopupWindow } from '../../components/skodaPopupWindow/skodaPopupWindow'
import { SkodaTooltip } from '../../components/skodaTooltip'
import { VinInput } from '../../components/vinInput/vinInput'
import { TabType, WizardTabPane } from '../../components/wizard/wizardTabs/WizardTabPane'
import { WizardTabsComponent } from '../../components/wizard/wizardTabs/WizardTabsComponent'
import { ResourceProvider } from '../../resourceProvider'
import { ApplicationState } from '../../store'
import { showFilterMobilePage } from '../../store/filterMobilePage/actions'
import { applyWizardFilter } from '../../store/filterPage/actions'
import { FilterState, WizardFilterActionPayload } from '../../store/filterPage/types'
import { pushGroupedServiceItems } from '../../store/overviewPage/actions'
import { fetchRequestInfotaiments, fetchRequestModels, fetchRequestProductionPeriods, fetchRequestVinCheckResult, hideWizardPage } from '../../store/wizardPage/actions'
import { TrackingProvider } from '../../tracking/trackingProvider'

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
	readonly isVisible: boolean,
	readonly loading: boolean,
	readonly wizardPage: TabType,
	readonly models: ISelectableItem[],
	readonly infotaiments: ISelectableItem[],
	readonly productionPeriods: ISelectableItem[],
	readonly actualFilter: FilterState,
	readonly externalWizardPageActivation: boolean,
	readonly changedProductionPeriods: boolean,
	readonly activateFilterOnClose: boolean,
	readonly vinCheckResult: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.VinCheckResultModel,
	readonly changedVinCheckResult: boolean,
	readonly errors?: string,
	readonly vinCheck: boolean,
	readonly isWizardPageLoading: boolean,
	readonly isCountryManuallySubmitted: boolean,
	readonly trackingProvider: TrackingProvider
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
	fetchRequestModels: typeof fetchRequestModels
	fetchRequestInfotaiments: typeof fetchRequestInfotaiments
	fetchRequestProductionPeriods: typeof fetchRequestProductionPeriods
	hideWizardPage: typeof hideWizardPage
	applyWizardFilter: typeof applyWizardFilter
	showFilterMobilePage: typeof showFilterMobilePage
	fetchRequestVinCheckResult: typeof fetchRequestVinCheckResult
	pushGroupedServiceItemsRequest: typeof pushGroupedServiceItems
}

interface WizardPageState {
	selectedWizardTab: TabType;
	dataFilter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter;
	wizardFilter: WizardFilterActionPayload;
	enteredVin: string;
	selectedModel: ISelectableItem;
	selectedInfotainment: ISelectableItem;
	selectedProductionPeriod: ISelectableItem;
	completedTabs: Array<TabType>;
	showPopUp: boolean;
	loadingServicesByVin: boolean;
	showFlashPopUp: boolean;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class WizardPage extends React.Component<AllProps, WizardPageState> {
	constructor(props: AllProps) {
		super(props);

		this.state = {
			selectedWizardTab: null,
			enteredVin: '',
			selectedModel: null,
			selectedInfotainment: null,
			selectedProductionPeriod: null,
			dataFilter: {
				...props.actualFilter.dataFilter
			},
			wizardFilter: {
				enteredVin: props.actualFilter.enteredVin,
				selectedModel: props.actualFilter.selectedModel,
				selectedInfotaiment: props.actualFilter.selectedInfotaiment,
				selectedProductionInterval: props.actualFilter.selectedProductionInterval,
				selectedVehicleMarketEntry: props.actualFilter.selectedVehicleMarketEntry
			},
			completedTabs: new Array<TabType>(),
			showPopUp: false,
			loadingServicesByVin: false,
			showFlashPopUp: false
		};

		this.selectTab = this.selectTab.bind(this);
		this.trackSelectedTabChanged = this.trackSelectedTabChanged.bind(this);
		this.selectModelsTab = this.selectModelsTab.bind(this);
		this.selectVinTab = this.selectVinTab.bind(this);
		this.selectInfotainmentTab = this.selectInfotainmentTab.bind(this);
		this.selectProductionPeriodTab = this.selectProductionPeriodTab.bind(this);

		this.requestVinResult = this.requestVinResult.bind(this);
		this.skipVinSearch = this.skipVinSearch.bind(this);
		this.requestInfotaiments = this.requestInfotaiments.bind(this);
		this.requestProductionPeriods = this.requestProductionPeriods.bind(this);

		this.changeVinCode = this.changeVinCode.bind(this);
		this.closePopUpWindow = this.closePopUpWindow.bind(this);
		this.changeSelectedModel = this.changeSelectedModel.bind(this);
		this.changeSelectedInfotainment = this.changeSelectedInfotainment.bind(this);
		this.changeSelectedProductionPeriod = this.changeSelectedProductionPeriod.bind(this);
		this.confirmProductionPeriod = this.confirmProductionPeriod.bind(this);
		this.skipProductionPeriod = this.skipProductionPeriod.bind(this);
		this.updateDataFilterToState = this.updateDataFilterToState.bind(this);
		this.updateWizardFilterToState = this.updateWizardFilterToState.bind(this);

		this.setSelectedModelToState = this.setSelectedModelToState.bind(this);
		this.setSelectedInfotainmentToState = this.setSelectedInfotainmentToState.bind(this);
		this.setSelectedProductionPeriodToState = this.setSelectedProductionPeriodToState.bind(this);

		this.getNextButtonClass = this.getNextButtonClass.bind(this);
		this.getSubmitButtonClass = this.getSubmitButtonClass.bind(this);
		this.removeItemFromArray = this.removeItemFromArray.bind(this);
		this.addItemToArray = this.addItemToArray.bind(this);

		this.onClose = this.onClose.bind(this);
		this.onBack = this.onBack.bind(this);
		this.trackPageView = this.trackPageView.bind(this);
	}

	readonly flashMessageBody: string = ".MOD.Flash.Message.";
	readonly flashMessageTitle: string = `${this.flashMessageBody}Title`;
	readonly flashMessageText: string = `${this.flashMessageBody}Text`;
	readonly flashMessageCloseButtonText: string = `${this.flashMessageBody}CloseButtonText`;

	public componentDidUpdate(prevProps: AllProps) {
		if (this.props.isVisible !== prevProps.isVisible) {
			document.body.classList.toggle("no-scroll");
		}
	}

	componentWillReceiveProps(nextProps: AllProps) {
		if (nextProps.externalWizardPageActivation) {
			let updatedWizardFilter = {
				enteredVin: nextProps.actualFilter.enteredVin,
				selectedModel: nextProps.actualFilter.selectedModel,
				selectedInfotaiment: nextProps.actualFilter.selectedInfotaiment,
				selectedProductionInterval: nextProps.actualFilter.selectedProductionInterval,
				selectedVehicleMarketEntry: nextProps.actualFilter.selectedVehicleMarketEntry
			}

			var selectedModelResolved: ISelectableItem;
			var selectedInfotaimentResolved: ISelectableItem;
			let selectedProductionIntervalResolved: ISelectableItem;
			let enteredVinResolved: string;

			selectedModelResolved = null;
			selectedInfotaimentResolved = null;
			selectedProductionIntervalResolved = null;
			enteredVinResolved = null

			this.updateWizardFilterToState(updatedWizardFilter);

			//get entered VIN
			if (nextProps.actualFilter.enteredVin != null) {
				enteredVinResolved = nextProps.actualFilter.enteredVin;
			}

			//get selectedModel
			if (nextProps.actualFilter.selectedModel != null) {
				if (this.props.models != null) {
					this.props.models.forEach(item => {
						if (item.code == nextProps.actualFilter.selectedModel.Code)
							selectedModelResolved = item;
					});
				}
			}

			//get selectedInfotainment
			if (nextProps.actualFilter.selectedInfotaiment != null) {
				if (this.props.infotaiments != null) {
					this.props.infotaiments.forEach(item => {
						if (item.code == nextProps.actualFilter.selectedInfotaiment.Code)
							selectedInfotaimentResolved = item;
					});
				}
			}

			//get selectedProductionPeriod
			if (nextProps.actualFilter.selectedProductionInterval != null) {
				if (this.props.productionPeriods != null) {
					this.props.productionPeriods.forEach(item => {
						if (item.code == nextProps.actualFilter.selectedProductionInterval.From.Code)
							selectedProductionIntervalResolved = item;
					});
				}
			}

			let completedTabs = new Array<TabType>();
			if (enteredVinResolved != null)
				this.addItemToArray(completedTabs, TabType.Vin);
			if (selectedModelResolved != null)
				this.addItemToArray(completedTabs, TabType.Model);
			if (selectedInfotaimentResolved != null)
				this.addItemToArray(completedTabs, TabType.Infotainment);
			if (selectedProductionIntervalResolved != null)
				this.addItemToArray(completedTabs, TabType.ProductionPeriod);

			if (nextProps.wizardPage == TabType.Model) {
				this.props.fetchRequestModels(nextProps.actualFilter.dataFilter);
			}

			this.setState({
				...this.state,
				wizardFilter: updatedWizardFilter,
				enteredVin: enteredVinResolved,
				selectedModel: selectedModelResolved,
				selectedInfotainment: selectedInfotaimentResolved,
				selectedProductionPeriod: selectedProductionIntervalResolved,
				selectedWizardTab: nextProps.wizardPage,
				dataFilter: { ...nextProps.actualFilter.dataFilter },
				completedTabs: completedTabs
			}, this.trackSelectedTabChanged);
		}
		else if (nextProps.changedProductionPeriods) {
			if ((nextProps.productionPeriods != null) && (nextProps.productionPeriods.length === 1)) {
				nextProps.productionPeriods[0].selected = true;

				let updatedWizardFilter = this.state.wizardFilter;
				updatedWizardFilter.selectedProductionInterval = nextProps.productionPeriods[0].data;

				this.setState({
					...this.state,
					wizardFilter: updatedWizardFilter,
					selectedProductionPeriod: nextProps.productionPeriods[0]
				});
			}
		}
		else if (nextProps.changedVinCheckResult && nextProps.vinCheckResult != null) {
			if (nextProps.vinCheckResult.ServiceGroup == null) {
				this.setState({
					...this.state,
					showPopUp: true,
					loadingServicesByVin: false
				});

				this.props.trackingProvider.trackVirtualPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, 'Vin error');
			}
			else {
				let updatedWizardFilter = this.state.wizardFilter;
				updatedWizardFilter.selectedModel = nextProps.vinCheckResult.ModelFamily;
				updatedWizardFilter.selectedInfotaiment = nextProps.vinCheckResult.Infotainment;
				updatedWizardFilter.selectedProductionInterval = nextProps.vinCheckResult.ProductionInterval;
				updatedWizardFilter.selectedVehicleMarketEntry = nextProps.vinCheckResult.VehicleMarketEntry;

				this.setState({
					...this.state,
					wizardFilter: updatedWizardFilter,
					loadingServicesByVin: false
				}, this.trackPageView);

				this.props.hideWizardPage();
				this.props.applyWizardFilter(this.state.wizardFilter);
				this.props.pushGroupedServiceItemsRequest(nextProps.vinCheckResult.ServiceGroup);
			}
		}
		else if (nextProps.errors) {
			this.setState({
				...this.state,
				showPopUp: true,
				loadingServicesByVin: false
			});

			this.props.trackingProvider.trackVirtualPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, 'Vin error');
		}
	}

	private selectTab(selectedWizardTab: TabType) {
		this.setState({
			...this.state,
			selectedWizardTab
		}, this.trackSelectedTabChanged);
	}

	private trackSelectedTabChanged() {
		if (this.state.selectedWizardTab === TabType.Model) {
			this.props.trackingProvider.trackVirtualPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, 'Choose vehicle model');
			this.props.trackingProvider.trackTabChange(`${this.props.vinCheck ? '2/4' : '1/3'} Model`);
		}
		else if (this.state.selectedWizardTab === TabType.Infotainment) {
			this.props.trackingProvider.trackVirtualPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, 'Choose vehicle infotainment');
			this.props.trackingProvider.trackTabChange(`${this.props.vinCheck ? '3/4' : '2/3'} Infotainment`);
		}
		else if (this.state.selectedWizardTab === TabType.ProductionPeriod) {
			this.props.trackingProvider.trackVirtualPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, 'Choose vehicle production period');
			this.props.trackingProvider.trackTabChange(`${this.props.vinCheck ? '4/4' : '3/3'} Production period`);
		}
		else if (this.state.selectedWizardTab === TabType.Vin) {
			this.props.trackingProvider.trackVirtualPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, 'VIN code');
			this.props.trackingProvider.trackTabChange('1/4 VIN code');
		}
	}

	private updateDataFilterToState(dataFilter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) {
		this.setState({
			...this.state,
			dataFilter
		});
	}

	private updateWizardFilterToState(wizardFilter: WizardFilterActionPayload) {
		this.setState({
			...this.state,
			wizardFilter
		});
	}

	private selectVinTab() {
		this.selectTab(TabType.Vin);
	}

	private selectModelsTab() {
		this.selectTab(TabType.Model);
	}

	private selectInfotainmentTab() {
		this.selectTab(TabType.Infotainment);
	}

	private selectProductionPeriodTab() {
		this.selectTab(TabType.ProductionPeriod);
	}

	private setSelectedModelToState(selectedModel: ISelectableItem) {
		this.setState({
			...this.state,
			selectedModel
		});
	}

	private setSelectedInfotainmentToState(selectedInfotainment: ISelectableItem) {
		this.setState({
			...this.state,
			selectedInfotainment
		});
	}

	private setSelectedProductionPeriodToState(selectedProductionPeriod: ISelectableItem) {
		this.setState({
			...this.state,
			selectedProductionPeriod
		});
	}

	private requestInfotaiments() {
		if (this.state.selectedModel) {
			this.props.trackingProvider.trackButtonClick(this.state.selectedModel.code, null, this.props.actualFilter.selectedCountry?.OriginValue, null, this.state.selectedModel.code);
		}

		let dataFilter = this.state.dataFilter;

		dataFilter.ProductionFromCode = null;
		dataFilter.ProductionToCode = null;
		dataFilter.InfotainmentCode = null;

		this.props.fetchRequestInfotaiments(dataFilter);

		let completedTabs = this.state.completedTabs;

		//reset all selected infotainments and production periods
		this.addItemToArray(completedTabs, TabType.Model);
		this.removeItemFromArray(completedTabs, TabType.Infotainment);
		this.removeItemFromArray(completedTabs, TabType.ProductionPeriod);

		this.setState({
			...this.state,
			selectedInfotainment: null,
			selectedProductionPeriod: null,
			selectedWizardTab: TabType.Infotainment,
			completedTabs: completedTabs,
			dataFilter: dataFilter
		}, this.trackSelectedTabChanged);
	}

	private requestProductionPeriods() {
		if (this.state.selectedInfotainment) {
			this.props.trackingProvider.trackButtonClick(this.state.selectedInfotainment.title, null, this.props.actualFilter.selectedCountry?.OriginValue, this.state.selectedInfotainment.title, this.state.wizardFilter.selectedModel?.Code);
		}

		let dataFilter = this.state.dataFilter;

		dataFilter.ProductionFromCode = null;
		dataFilter.ProductionToCode = null;

		this.props.fetchRequestProductionPeriods(dataFilter);

		let completedTabs = this.state.completedTabs;
		this.addItemToArray(completedTabs, TabType.Infotainment);

		this.setState({
			...this.state,
			selectedWizardTab: TabType.ProductionPeriod,
			completedTabs: completedTabs,
			dataFilter: dataFilter
		}, this.trackSelectedTabChanged);
	}

	private confirmProductionPeriod() {
		this.props.trackingProvider.trackButtonClick(this.state.selectedProductionPeriod.data.From.ProductionDate, null, this.props.actualFilter.selectedCountry?.OriginValue, this.state.wizardFilter.selectedInfotaiment?.Title, this.state.wizardFilter.selectedModel?.Code, this.state.wizardFilter.selectedProductionInterval?.From?.ProductionDate);

		let completedTabs = this.state.completedTabs;
		this.addItemToArray(completedTabs, TabType.ProductionPeriod);

		this.setState({
			...this.state,
			completedTabs: completedTabs
		}, this.trackPageView);

		this.props.hideWizardPage();
		this.props.applyWizardFilter(this.state.wizardFilter);
	}

	private skipProductionPeriod() {
		this.props.trackingProvider.trackButtonClick('Skip production period', null, this.props.actualFilter.selectedCountry?.OriginValue, this.state.wizardFilter.selectedInfotaiment?.Title, this.state.wizardFilter.selectedModel?.Code);

		this.changeSelectedProductionPeriod(null);
		this.props.hideWizardPage();
		this.props.applyWizardFilter(this.state.wizardFilter);
		this.trackPageView();
	}

	private requestVinResult() {
		this.props.trackingProvider.trackButtonClick('Confirm VIN code');

		let completedTabs = this.state.completedTabs;
		let wizardFilter = this.state.wizardFilter;

		this.addItemToArray(completedTabs, TabType.Vin);
		this.removeItemFromArray(completedTabs, TabType.Model);
		this.removeItemFromArray(completedTabs, TabType.Infotainment);
		this.removeItemFromArray(completedTabs, TabType.ProductionPeriod);

		wizardFilter.selectedModel = null;
		wizardFilter.selectedInfotaiment = null;
		wizardFilter.selectedProductionInterval = null;
		wizardFilter.selectedVehicleMarketEntry = null;

		let dataFilter = this.state.dataFilter;
		dataFilter.FamilyCode = null;
		dataFilter.InfotainmentCode = null;
		dataFilter.ProductionFromCode = null;
		dataFilter.ProductionToCode = null;

		this.props.fetchRequestVinCheckResult(dataFilter);

		this.setState({
			...this.state,
			completedTabs: completedTabs,
			wizardFilter: wizardFilter,
			loadingServicesByVin: true
		});
	}

	private skipVinSearch() {
		this.props.trackingProvider.trackButtonClick('Skip VIN code');

		let dataFilter = this.state.dataFilter;
		let wizardFilter = this.state.wizardFilter;

		wizardFilter.enteredVin = null;

		dataFilter.EnteredVin = null;
		dataFilter.FamilyCode = null;
		dataFilter.ProductionFromCode = null;
		dataFilter.ProductionToCode = null;
		dataFilter.InfotainmentCode = null;

		this.props.fetchRequestModels(dataFilter);

		let completedTabs = this.state.completedTabs;

		//reset all selected models, infotainments and production periods
		this.removeItemFromArray(completedTabs, TabType.Vin);
		this.removeItemFromArray(completedTabs, TabType.Model);
		this.removeItemFromArray(completedTabs, TabType.Infotainment);
		this.removeItemFromArray(completedTabs, TabType.ProductionPeriod);

		this.setState({
			...this.state,
			selectedModel: null,
			selectedInfotainment: null,
			selectedProductionPeriod: null,
			selectedWizardTab: TabType.Model,
			completedTabs: completedTabs,
			wizardFilter: wizardFilter,
			dataFilter: dataFilter
		}, this.trackSelectedTabChanged);
	}

	private removeItemFromArray(data: Array<TabType>, itemToDelete: TabType) {
		const index = data.indexOf(itemToDelete);
		if (index > -1) {
			data.splice(index, 1);
		}
	}

	private addItemToArray(data: Array<TabType>, itemToAdd: TabType) {
		const index = data.indexOf(itemToAdd);
		if (index == -1) {
			data.push(itemToAdd);
		}
	}

	private closeFlashPopUpWindow() {
		this.setState({
			...this.state,
			showFlashPopUp: false
		});
	}

	private changeSelectedModel(selectedModel: ISelectableItem) {
		let dataFilter = this.state.dataFilter;
		let wizardFilter = this.state.wizardFilter;

		let completedTabs = this.state.completedTabs;

		if (selectedModel != null) {
			dataFilter.FamilyCode = selectedModel.code;
			dataFilter.InfotainmentCode = null;
			dataFilter.ProductionFromCode = null;
			dataFilter.ProductionToCode = null;

			wizardFilter.selectedModel = selectedModel.data;
		}
		else {
			dataFilter.FamilyCode = null;
			dataFilter.InfotainmentCode = null;
			wizardFilter.selectedModel = null;
			this.removeItemFromArray(completedTabs, TabType.Model);
		}

		this.setState({
			...this.state,
			dataFilter: dataFilter,
			wizardFilter: wizardFilter,
			selectedModel: selectedModel,
			completedTabs: completedTabs,
			showFlashPopUp: this.isModFlash(selectedModel?.code)
		});
	}

	private changeSelectedInfotainment(selectedInfotainment: ISelectableItem) {
		let dataFilter = this.state.dataFilter;
		let wizardFilter = this.state.wizardFilter;

		let completedTabs = this.state.completedTabs;

		if (selectedInfotainment != null) {
			dataFilter.InfotainmentCode = selectedInfotainment.code;
			dataFilter.ProductionFromCode = null;
			dataFilter.ProductionToCode = null;
			wizardFilter.selectedInfotaiment = selectedInfotainment.data;
		}
		else {
			dataFilter.InfotainmentCode = null;
			dataFilter.ProductionFromCode = null;
			dataFilter.ProductionToCode = null;
			wizardFilter.selectedInfotaiment = null;
			this.removeItemFromArray(completedTabs, TabType.Infotainment);
		}

		this.setState({
			...this.state,
			dataFilter: dataFilter,
			wizardFilter: wizardFilter,
			selectedInfotainment: selectedInfotainment,
			completedTabs: completedTabs
		});
	}

	private changeSelectedProductionPeriod(selectedProductionInterval: ISelectableItem) {
		let wizardFilter = this.state.wizardFilter;

		let completedTabs = this.state.completedTabs;

		if (selectedProductionInterval != null) {
			wizardFilter.selectedProductionInterval = selectedProductionInterval.data;
		}
		else {
			wizardFilter.selectedProductionInterval = null;
			this.removeItemFromArray(completedTabs, TabType.ProductionPeriod);
		}

		this.setState({
			...this.state,
			wizardFilter: wizardFilter,
			selectedProductionPeriod: selectedProductionInterval,
			completedTabs: completedTabs
		});
	}

	private getNextButtonClass(selectedItem: any): string {
		if (selectedItem != null) {
			return "active";
		}

		return "inactive";
	}

	private getSubmitButtonClass(): string {
		if (this.state.enteredVin != null && this.state.enteredVin.length == 17)
			return "active";

		return "inactive";
	}

	private onClose() {
		this.props.hideWizardPage();

		if (this.props.activateFilterOnClose)
			this.props.showFilterMobilePage();

		this.trackPageView(true);
	}

	private trackPageView(onClose: boolean = false): void {
		let infotainment = this.state.wizardFilter.selectedInfotaiment?.Title;
		let model = this.state.wizardFilter.selectedModel?.Code;
		let productionDate = this.state.wizardFilter.selectedProductionInterval?.From?.ProductionDate

		if (onClose) {
			infotainment = this.props.actualFilter.selectedInfotaiment?.Title;
			model = this.props.actualFilter.selectedModel?.Code;
			productionDate = this.props.actualFilter.selectedProductionInterval?.From?.ProductionDate
        }

		this.props.trackingProvider.trackPageView(this.props.actualFilter.dataFilter.ImporterBid, this.props.actualFilter.dataFilter.Culture, this.props.actualFilter.selectedCountry?.OriginValue, infotainment, model, productionDate);
	}

	private onBack() {
		switch (this.state.selectedWizardTab) {
			case TabType.Model:
				this.selectTab(TabType.Vin);
				break;
			case TabType.Infotainment:
				this.selectTab(TabType.Model);
				break;
			case TabType.ProductionPeriod:
				this.selectTab(TabType.Infotainment);
				break;
		}
	}

	private changeVinCode(vin: string, autoSubmit: boolean) {
		let dataFilter = this.state.dataFilter;
		let wizardFilter = this.state.wizardFilter;

		dataFilter.EnteredVin = vin;
		wizardFilter.enteredVin = vin;

		this.setState({
			...this.state,
			dataFilter: dataFilter,
			wizardFilter: wizardFilter,
			enteredVin: vin
		}, () => {
			if (autoSubmit && !this.props.isCountryManuallySubmitted) {
				this.requestVinResult();
			}
		});
	}

	private closePopUpWindow() {
		this.setState({
			...this.state,
			showPopUp: false
		});
	}

	private isModFlash(modelCode: string): boolean {
		if (this.modFlashResourceChecker(modelCode, this.flashMessageTitle) &&
			this.modFlashResourceChecker(modelCode, this.flashMessageText) &&
			this.modFlashResourceChecker(modelCode, this.flashMessageCloseButtonText))
			return true;
		else {
			return false;
		}
	}

	private modFlashConverter(text: string): string {
		return text.toUpperCase().replace(/\s/g, "");
	}

	private modFlashResourceChecker(modelCode: string, expectedKey: string): boolean {
		if (!modelCode || !expectedKey)
			return false;

		let convertedCode = this.modFlashConverter(modelCode);

		let concated = convertedCode.concat(expectedKey);
		let resource = ResourceProvider.getText(concated);
		if (!resource || resource === `#${concated}`) {
			return false;
		}
		else {
			return true;
		}
	}

	ModFlashPopup = (modelCode: string) => (
		<>
			{
				this.state.showFlashPopUp ?
					<SkodaPopupWindow
						title={ResourceProvider.getText(this.modFlashConverter(modelCode).concat(this.flashMessageTitle))}
						text={ResourceProvider.getText(this.modFlashConverter(modelCode).concat(this.flashMessageText))}
						closeButtonText={ResourceProvider.getText(this.modFlashConverter(modelCode).concat(this.flashMessageCloseButtonText))}
						onClose={this.closeFlashPopUpWindow.bind(this)} />
					: null
			}
		</>
	)

	ModFlashTooltip = (modelCode: string) => (
		<>
			{
				this.isModFlash(modelCode) &&
				<SkodaTooltip id="flashTooltip" effect={"solid"} type={"dark"} position={"left"} message={ResourceProvider.getText(this.modFlashConverter(modelCode).concat(this.flashMessageText))}>
					<span className="wizard-page-info-text">{ResourceProvider.getText(this.modFlashConverter(modelCode).concat(this.flashMessageTitle))}</span>
					<span className="wizard-page-skipWarning-image"></span>
				</SkodaTooltip>
			}
		</>
	)

	public render() {
		const { isVisible, models, infotaiments, productionPeriods, loading, errors } = this.props;
		const { selectedWizardTab, showPopUp, loadingServicesByVin, selectedModel } = this.state;
		let vinSearchTabLoading = (selectedWizardTab == TabType.Vin && loading) ? true : false;
		let isVisibleSkipButton = (this.props.productionPeriods != null && this.props.productionPeriods.length === 1) ? false : true;
		let isVisibleVinSkipButton = selectedWizardTab == TabType.Vin;

		return (
			isVisible ?
				<div className={vinSearchTabLoading ? "wizard-page inactive" : "wizard-page"}>
					<WizardTabsComponent selectedTab={selectedWizardTab} animate={true} onClose={this.onClose} onBack={this.onBack} onSelect={this.selectTab} completedTabs={this.state.completedTabs} vinCheck={this.props.vinCheck}>
						{
							this.props.vinCheck &&
							<WizardTabPane name={TabType.Vin} title={ResourceProvider.getText('WizardPage.Vin.Label')}>
								<h4 className="wizard-page-tabHeader">{ResourceProvider.getText('WizardPage.Vin.TabLabel')}</h4>
								<div className="wizard-page-textInput-content">
									<VinInput id="vinSearchTextInput" label={ResourceProvider.getText('WizardPage.Vin.TextInputLabel')} value={this.state.enteredVin} onChange={this.changeVinCode} validationLength={17} loadingServicesByVin={loadingServicesByVin} />
									{
										showPopUp ?
											<div><SkodaPopupWindow
												title={errors ? ResourceProvider.getText('ErrorTitle.VinResult') : ResourceProvider.getText('NoSkodaConnect.Title')}
												text={errors ? ResourceProvider.getText('ErrorMsg.VinResult') : ResourceProvider.getText('NoSkodaConnect.Text')} onClose={this.closePopUpWindow}
												closeButtonText={ResourceProvider.getText('PopupWindow.Close')} />
											</div>
											: null
									}
								</div>
								<div className="wizard-page-footer vin">
									<div className="wizard-page-flexGrid">
										{
											isVisibleVinSkipButton &&
											<div className="next-button-mobile" onClick={this.skipVinSearch}>
												<div className="skipText">{ResourceProvider.getText('WizardPage.Skip')}</div>
											</div>
										}
										<button className="next-button skip" onClick={this.skipVinSearch}>{ResourceProvider.getText('WizardPage.Skip')}</button>
										<button className={`next-button ${this.getSubmitButtonClass()}`} onClick={this.requestVinResult}>{ResourceProvider.getText('WizardPage.Confirm')}</button>
										<div className="wizard-page-info">
											<SkodaTooltip id="vinCodeTooltip" effect={"solid"} type={"dark"} message={ResourceProvider.getText('WizardPage.Vin.TooltipContent')}>
												<span className="wizard-page-info-text">{ResourceProvider.getText('WizardPage.Vin.Tooltip')}</span>
												<span className="wizard-page-info-image"></span>
											</SkodaTooltip>
										</div>
									</div>
									<div className="wizard-page-skipInfo">
										<span className="wizard-page-skipInfo-text">{ResourceProvider.getText('WizardPage.Vin.SkipInfo')}</span>
									</div>
								</div>
							</WizardTabPane>
						}

						<WizardTabPane name={TabType.Model} title={ResourceProvider.getText('WizardPage.Model.Label')}>
							<h4 className="wizard-page-tabHeader">{ResourceProvider.getText('WizardPage.Model.TabLabel')}</h4>
							<SelectableItemContainer id={'Models'}
								items={models}
								layout={Layout.Vertical}
								contentCentered={false}
								contentCenteredVertical={true}
								uppercase={false}
								onSelect={this.changeSelectedModel}
								selectedItem={this.state.selectedModel}
								itemClassName={TabType[TabType.Model].toString().toLowerCase()} />
							<div className="wizard-page-footer model">
								<button className={`next-button ${this.getNextButtonClass(this.state.wizardFilter.selectedModel)}`} onClick={this.requestInfotaiments}>{ResourceProvider.getText('WizardPage.Next')}</button>
							</div>
							{
								this.ModFlashPopup(selectedModel?.code)
							}
						</WizardTabPane>

						<WizardTabPane name={TabType.Infotainment} title={ResourceProvider.getText('WizardPage.Infotainment.Label')}>
							<h4 className="wizard-page-tabHeader">{ResourceProvider.getText('WizardPage.Infotainment.TabLabel')}</h4>
							<SelectableItemContainer id={'Infotainments'}
								items={infotaiments}
								layout={Layout.Vertical}
								contentCentered={true}
								contentCenteredVertical={true}
								uppercase={false}
								onSelect={this.changeSelectedInfotainment}
								selectedItem={this.state.selectedInfotainment}
								itemClassName={TabType[TabType.Infotainment].toString().toLowerCase()} />
							<div className="wizard-page-footer infotaiment">
								<div className="wizard-page-flexGrid">
									<button className={`next-button ${this.getNextButtonClass(this.state.wizardFilter.selectedInfotaiment)}`} onClick={this.requestProductionPeriods}>{ResourceProvider.getText('WizardPage.Next')}</button>
									<div className="wizard-page-info">
										{
											this.ModFlashTooltip(selectedModel?.code)
										}
										<SkodaTooltip id="infotainmentTooltip" effect={"solid"} type={"dark"} position="left" message={ResourceProvider.getText('WizardPage.Infotainment.TooltipContent')}>
											<span className="wizard-page-info-text">{ResourceProvider.getText('WizardPage.Infotainment.Tooltip')}</span>
											<span className="wizard-page-info-image"></span>
										</SkodaTooltip>
									</div>
								</div>
							</div>
						</WizardTabPane>
						<WizardTabPane name={TabType.ProductionPeriod} title={ResourceProvider.getText('WizardPage.ProductionPeriod.Label')}>
							<h4 className="wizard-page-tabHeader">{ResourceProvider.getText('WizardPage.ProductionPeriod.TabLabel')}</h4>

							<SelectableItemContainer id={'Periods'}
								itemTitleClassName={"mt-n3 mb-4"}
								items={productionPeriods}
								layout={Layout.Horizontal}
								contentCentered={true}
								uppercase={false}
								onSelect={this.changeSelectedProductionPeriod}
								selectedItem={this.state.selectedProductionPeriod}
								itemClassName={TabType[TabType.ProductionPeriod].toString().toLowerCase() + " col-centered"} />

							<div className="wizard-page-footer productionperiods">
								<div className="wizard-page-flexGrid">

									{isVisibleSkipButton && <div className="next-button-mobile" onClick={this.skipProductionPeriod}>
										<div className="skipImage" />
										<div className="skipText">{ResourceProvider.getText('WizardPage.Skip')}</div>
									</div>}

									{isVisibleSkipButton && <button className="next-button skip"
										onClick={this.skipProductionPeriod}>{ResourceProvider.getText('WizardPage.Skip')}</button>}

									<button className={`next-button ${this.getNextButtonClass(this.state.wizardFilter.selectedProductionInterval)}`} onClick={this.confirmProductionPeriod}>
										{ResourceProvider.getText('WizardPage.Confirm')}</button>

									<div className="wizard-page-info">
										{
											this.ModFlashTooltip(selectedModel?.code)
										}
										<SkodaTooltip id="productionPeriodTooltip" effect={"solid"} type={"dark"} position={"left"} message={ResourceProvider.getText('WizardPage.ProductionPeriod.TooltipContent')}>
											<span className="wizard-page-info-text">{ResourceProvider.getText('WizardPage.ProductionPeriod.Tooltip')}</span>
											<span className="wizard-page-info-image"></span>
										</SkodaTooltip>
									</div>
								</div>

								{isVisibleSkipButton &&
									<div className="wizard-page-skipWarning">
										<div className="wizard-page-skipWarning-image" />
										<span className="wizard-page-skipWarning-text">{ResourceProvider.getText('WizardPage.ProductionPeriod.SkipWarning')}</span>
									</div>
								}
							</div>
						</WizardTabPane>

					</WizardTabsComponent>
				</div>
				: null
		);
	}
}

const mapStateToProps = ({ wizardPage, filter, common }: ApplicationState) => ({
	isVisible: wizardPage.isVisible,
	loading: wizardPage.loading,
	wizardPage: wizardPage.wizardTab,
	models: wizardPage.models,
	infotaiments: wizardPage.infotaiments,
	productionPeriods: wizardPage.productionPeriods,
	actualFilter: filter,
	externalWizardPageActivation: wizardPage.externalWizardPageActivation,
	changedProductionPeriods: wizardPage.changedProductionPeriods,
	activateFilterOnClose: wizardPage.activateFilterOnClose,
	vinCheckResult: wizardPage.vinCheckResult,
	changedVinCheckResult: wizardPage.changedVinCheckResult,
	errors: wizardPage.errors,
	vinCheck: wizardPage.vinCheck,
	isWizardPageLoading: wizardPage.loading,
	isCountryManuallySubmitted: filter.isCountryManuallySubmitted,
	trackingProvider: common.trackingProvider
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchRequestModels: (filter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) => dispatch(fetchRequestModels(filter)),
	fetchRequestInfotaiments: (filter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) => dispatch(fetchRequestInfotaiments(filter)),
	fetchRequestProductionPeriods: (filter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) => dispatch(fetchRequestProductionPeriods(filter)),
	fetchRequestVinCheckResult: (filter: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Filters.DataFilter) => dispatch(fetchRequestVinCheckResult(filter)),
	hideWizardPage: () => dispatch(hideWizardPage()),
	applyWizardFilter: (wizardFilterActionPayload: WizardFilterActionPayload) => dispatch(applyWizardFilter(wizardFilterActionPayload)),
	showFilterMobilePage: () => dispatch(showFilterMobilePage()),
	pushGroupedServiceItemsRequest: (data: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceGroupModel[]) => dispatch(pushGroupedServiceItems(data)),
})

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WizardPage)